import React from 'react';
import { useWindowSize } from '../../hooks/useWindowSize';

export default function Topbar({ title, subtitle, actions }) {
  const { isMobile } = useWindowSize();

  const today = new Date().toLocaleDateString('it-IT', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });

  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: isMobile ? '14px 16px 12px 64px' : '20px 28px 16px',
      borderBottom: '1px solid var(--border)',
      position: 'sticky',
      top: 0,
      background: 'var(--navy)',
      zIndex: 10,
      minHeight: '60px',
    }}>
      <div style={{ minWidth: 0, flex: 1 }}>
        <h1 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: isMobile ? '18px' : '22px',
          fontWeight: 500,
          whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
        }}>
          {title}
        </h1>
        {!isMobile && (
          <p style={{ fontSize: '12.5px', color: 'var(--text-muted)', marginTop: '2px' }}>
            {subtitle || today}
          </p>
        )}
      </div>
      {actions && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0, marginLeft: '12px' }}>
          {actions}
        </div>
      )}
    </header>
  );
}
